import React, { useMemo } from "react";
import { useHistory, useLocation } from "react-router";
import { X as CloseIcon } from "react-feather";

import EventInfoSidebar from "./EventInfoSidebar";
import EventsListSidebar from "./EventsListSidebar";

const EventsListSidebarRoot = () => {

  const history = useHistory();
  const location = useLocation();

  const eventInfo = useMemo(() => {
    const eventId = new URLSearchParams(location.search).get("eventId");
    const ticketId = new URLSearchParams(location.search).get("ticketId");
    if (eventId && ticketId) {
      return {
        eventId,
        ticketId,
      }
    }
  }, [location.search]);

  const close = () => {
    history.replace("/events/list");
  };

  return (
    <div className="sidebarWrapper">
      {eventInfo
        ? (
          <>
            <EventInfoSidebar {...eventInfo} />
            <CloseIcon
              className="sidebarWrapper__icon nav-icon mt-2 mr-2 text-secondary"
              onClick={() => close()}
            />
          </>
        )
        : (<EventsListSidebar />)}
    </div>
  );
};

export default EventsListSidebarRoot;
